import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  setPriorityItems: []
});

const INITIAL_STATE: { items: [] } = { items: [] };

const setPriorityItems = (state = INITIAL_STATE, action: any) => {
  return { ...state, items: action.data.data };
};

export default createReducer(INITIAL_STATE, {
    [Types.SET_PRIORITY_ITEMS]: setPriorityItems
});
